import { useState } from "react";
import { Form } from "react-router-dom";
import FormControl from "react-bootstrap/FormControl";

import { useForm } from "../../hooks/useForm";
import { useTitle } from "../../hooks/useTitle";
import { requestPasswordReset } from "../../services/ledgerService";

import "./auth.css";

export function ForgotPasswordPage() {
    useTitle("Reset your password");
    const [submitted, setSubmitted] = useState(false);
    const { handleSubmit, status, message } = useForm(requestPasswordReset, () =>
        setSubmitted(true)
    );

    return (
        <section className="mkt-auth">
            <div className="mkt-auth-mast">
                <div className="mkt-auth-mast-kicker">Reset password</div>
                <h1>
                    Forgot your <em>password?</em>
                </h1>
                <p>
                    Enter the email on your Poker Ledger account and we'll send a
                    link to set a new one.
                </p>
            </div>

            <div className="mkt-auth-card">
                {submitted ? (
                    <div className="mkt-auth-form">
                        <p>
                            If an account exists for that email, we've sent a link to
                            reset your password. It expires in 60 minutes.
                        </p>
                        <div className="mkt-auth-foot">
                            <a href="/login">Back to sign in</a>
                        </div>
                    </div>
                ) : (
                    <>
                        <Form
                            method="post"
                            replace
                            onSubmit={handleSubmit}
                            className="mkt-auth-form"
                        >
                            <div>
                                <label className="mkt-auth-label" htmlFor="reset-email">
                                    Email
                                </label>
                                <FormControl
                                    id="reset-email"
                                    required
                                    name="email"
                                    type="email"
                                    placeholder="you@example.com"
                                />
                            </div>
                            <button type="submit" disabled={status === "loading"}>
                                {status === "loading" ? "Sending…" : "Send reset link"}
                            </button>
                            {message && (
                                <div className="mkt-auth-error">{message}</div>
                            )}
                        </Form>
                        <div className="mkt-auth-foot">
                            Remembered it? <a href="/login">Sign in</a>
                        </div>
                    </>
                )}
            </div>
        </section>
    );
}
